<template>
    <div class="footer-box">
        <div class="footer">
            <ul class="web-info">
                <li class="web-info-list-border"><a href="/helpcenter.html" style="padding-left:0;" target="_blank">帮助中心</a></li>
                <li class="web-info-list-border"><a href="/companyprofile.html" target="_blank">关于我们</a></li>
                <li class="web-info-list-border"><a href="/advicefeedback.html" target="_blank">意见反馈</a></li>
                <li class="web-info-list-border"><a href="/legalstatement.html" target="_blank">隐私政策</a></li>
                <li class="web-info-list-border"><a href="/contactus.html" target="_blank">联系我们</a></li>
                <li><a href="/invitecode.html" target="_blank">邀请码</a></li>
            </ul>
            <div class="line-bottom"></div>
            <div class="copy-right">
                <span>京ICP备19038458号-1</span>
                <span style="margin-right: 70px;"><a style="text-decoration:none;color: #999;" href="https://beian.mps.gov.cn/#/query/webSearch?code=13068102000404" rel="noreferrer" target="_blank">冀公网安备13068102000404号</a></span>
                <span>版权所有：北京北门逐鹿影视传媒有限公司2020</span>
            </div>
            <div class="contact-box">
                <!-- <div @mouseenter="wxCodeShow = true" @mouseleave="wxCodeShow = false">
                    <img src="../assets/2021/wechat.png" alt="">
                    <img src="../assets/2021/wx-code.png" alt="" class="code-img" v-show="wxCodeShow">
                </div> -->
                <div @mouseenter="xcxCodeShow = true" @mouseleave="xcxCodeShow = false">
                    <img src="../assets/2021/feedback.png" alt="">
                    <img src="../assets/2021/xcx-code.png" alt="" class="code-img" v-show="xcxCodeShow">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data(){
        return{
            wxCodeShow:false,
            xcxCodeShow:false
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer-box{
    height:124px;
    background:#282828;
    box-sizing:content-box;
    padding:50px 0 0 25px;
    .footer{
        height:124px;
        width:1200px;
        margin:0 auto;
        position:relative;
        .line-bottom{
            height:1px;
            width:740px;
            // background:-webkit-linear-gradient(left,#F5F5F5, #ccc, #F5F5F5);
            background:#999;
            margin-bottom:20px;
        }
        .copy-right{
            text-align:left;
            font-size:14px;
            color:#999;
            span{
                letter-spacing:1px;
            }
            span:first-child{
                margin-right:70px;
            }
        }
        .link{
            margin-bottom:23px;
            font-size:18px;
        }
        .web-info{
            overflow:hidden;
            display:flex;
            justify-content:left;
            margin-bottom:40px;
            font-size: 16px;
            li{
                color:#999;
                position:relative;
                a{
                    text-decoration:none;
                    color:#999;
                    padding:0 30px;
                }
            }
            .web-info-list-border::after{
                content:"";
                display:block;
                position:absolute;
                width:1px;
                height:10px;
                background:#ccc;
                right:0;
                top:50%;
                transform:translateY(-40%);
            }
        }
        .contact-box{
            width:120px;
            height:56px;
            line-height:56px;
            position:absolute;
            right:0;
            top:-10px;
            div{
                display:inline-block;
                position:relative;
                margin-right:30px;
            }
            .code-img{
                width:130px;
                height:134px;
                position:absolute;
                left:-54px;
                bottom:120px;
            }
            img{
                width:30px;
                height:30px;
                vertical-align:top;
                cursor:pointer;
                transform: translateY(50%);
            }
        }
    }
}
</style>